let ownerId: string | null = null;

export function getAccountOwner(): string | null {
  return ownerId;
}

export function setAccountOwner(id: string | null) {
  ownerId = id && id.trim() ? id.trim() : null;
}

export function accountStorageKey(suffix: string): string {
  if (!ownerId) return `ukrop-nm.${suffix}`;
  return `ukrop-nm.u.${ownerId}.${suffix}`;
}

export const ACCOUNT_CHANGED_EVENT = 'ukrop-nm-account-changed';
export const SETTINGS_CHANGED_EVENT = 'ukrop-nm-settings-changed';

export function emitAccountChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(ACCOUNT_CHANGED_EVENT));
}

export function emitSettingsChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SETTINGS_CHANGED_EVENT));
}
